export const STATUTS_COMMANDE = {
  commandee: "COMMANDEE",
  annulee: "ANNULEE",
  refusee: "REFUSEE",
  erreur: "ERREUR",
  dejaTraitee: "DEJA_TRAITEE",
  validee: "VALIDEE",
  enAttente: "EN_ATTENTE",
  retiree: "RETIREE"
};
